// extracted by mini-css-extract-plugin
export default {"faqs":"_k-z","faqContent":"al-z","faq":"bl-z"};